import { useRef, useState } from 'react';
import ContactInput from "../ContactInput";

const Form6 = ({ submitHandler, changeHandler, loading=false }) => {
  const progName = useRef(null);
  const progEmail = useRef(null);
  const [ phone, setPhone ] = useState(null)


  const sendHandler = (e) => {
    e.preventDefault();
    submitHandler();
  }


  return(
    <div className="programsContainer programsContainer6">
        <div className="fo-26 txtco text-center fw-600 mfo-22 cmfo-18">You’re almost done!</div>
        <div className="fo-22 txtco text-center mfo-13 mt-4 cmfo-14">After submitting this form, our consultant shall <br></br>reach out to you within 48 hours to guide you.</div>
        
        <form className='text-center' onSubmit={sendHandler}>
            <input name="name" className="contactInput mt-4" placeholder="Name" onChange={(e) => changeHandler({ name: e.target.value })} required ref={progName}/>
            <div className='prog_contact'>
              <ContactInput value={phone && phone.number} onChange={(value) => changeHandler({
                phone: value.code + value.number
              })} required/>
            </div>

            <input type="email" ref={progEmail} name="email" className="contactInput" placeholder="Email" onChange={(e) => changeHandler({ email: e.target.value })} required/>
            <textarea name="message" className="contactTextarea mt-4" placeholder="Your Message (Optional)" 
            onChange={(e) => changeHandler({ message: e.target.value })}></textarea>
            <button type="submit" className="btn sendButton pulsating" disabled={loading}>
              Submit
            </button>
          </form>
    </div>
  )
}

export default Form6;
